export default __webpack_public_path__ + "static/media/category-1.fcd92789.webp";